import ApiClient from './ApiClient';

class ContractsClient extends ApiClient {
  constructor(url) {
    super(url ? `${url}` : '');
  }

  async getContracts() {
    try {
      const { contracts } = await this.get('/contracts');
      return contracts;
    } catch (error) {
      throw new Error(`Failed to fetch contracts: ${error?.message || error}`);
    }
  }

  async createContract(contractData) {
    try {
      const data = await this.post('/contracts', contractData);
      return data;
    } catch (error) {
      throw new Error(`Failed to create contract: ${error?.message || error}`);
    }
  }

  async updateContract(id, contractData) {
    try {
      const data = await this.put(`/contracts/${id}`, contractData);
      return data;
    } catch (error) {
      throw new Error(
        `Failed to update contract ${id}: ${error?.message || error}`
      );
    }
  }
}

export default ContractsClient;
